export default class MeetingInfo {
	constructor(init) {
		if (init) {
			this.id = init.id;
			this.dealId = init.dealId;
			this.employeeId = init.employeeId;
			this.employeeCode = init.employeeCode;
			this.inStore = init.inStore;
			this.language = init.language;
			this.dealNumber = init.dealNumber;
			this.storeCode = init.storeCode;
			this.meetingCode = init.meetingCode;
			//this.verificationCode = MeetingHelper.createNumberCode(6);
			this.validAfter = init.validAfter;
			this.validUntil = init.validUntil;
			this.startedAt = init.startedAt;
			this.finishedAt = init.finishedAt;

			this.meetings = [];
			this.meetingLogs = [];
		} else {
			this.id = null;
			this.dealId = null;
			this.employeeId = null;
			this.employeeCode = null;
			this.inStore = null;
			this.language = null;
			this.dealNumber = null;
			this.storeCode = null;
			this.meetingCode = null;
			//this.verificationCode = MeetingHelper.createNumberCode(6);
			this.validAfter = null;
			this.validUntil = null;
			this.startedAt = null;
			this.finishedAt = null;

			this.meetings = [];
			this.meetingLogs = [];
		}
	}
}
